var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hp-banner"},[_c('img',{staticClass:"hp-banner-img",attrs:{"src":require('@/assets/Presentation.png'),"alt":"Hot Pursuit — poursuite en ville","loading":"eager"}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hp-banner-overlay"},[_c('h1',{staticClass:"hp-banner-title"},[_vm._v("HOT PURSUIT")]),_c('span',{staticClass:"hp-banner-sub"},[_vm._v("Club Baby Pro")])])
}]

export { render, staticRenderFns }